import { hasUserRole, type UserLike } from '@/client/services/user'
import { getWorldLevelTitle } from '@/client/services/worlds'

import type { AugmentedWorldLevel } from '../types'

export function getAugmentedWorldLevel({
  user,
  level,
}: {
  user?: UserLike | null
  level: AugmentedWorldLevel | null
}): AugmentedWorldLevel | null {
  if (user == null) {
    return level
  }
  if (hasUserRole(user, 'admin:super') || hasUserRole(user, 'admin:intern')) {
    return 'admin'
  }
  return level
}

export function getAugmentedLevelTitle({
  worldSlug,
  augmentedLevel,
}: {
  worldSlug?: string
  augmentedLevel: AugmentedWorldLevel
}): string {
  switch (augmentedLevel) {
    case 'admin': {
      return 'Admin'
    }
    case 'member':
    case 'tutor':
    case 'senior-tutor':
    case 'coach':
    case 'moderator': {
      return getWorldLevelTitle({
        worldSlug,
        level: augmentedLevel,
      })
    }
  }
}
